// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__f1+2p","rotate":"Loader_rotate__pSbjn"};